import styles from "./Blockquote.module.scss";

type BlockquoteProps = {
  dataQa?: string;
  children: React.ReactNode;
};

const Blockquote = ({ children, dataQa }: BlockquoteProps) => (
  <blockquote
    data-test-id={`blockquote-${dataQa}`}
    className={styles.blockQuote}
  >
    {`"${children}"`}
  </blockquote>
);

export default Blockquote;
